<!--  <template>-->
<!--      <div class="relative">-->
<!--          &lt;!&ndash; Navigation arrows &ndash;&gt;-->
<!--          <button-->
<!--              @click="scrollLeft"-->
<!--              class="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow text-gray-400 hover:text-gray-600 transition-colors"-->
<!--              :disabled="!canScrollLeft"-->
<!--          >-->
<!--              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>-->
<!--              </svg>-->
<!--          </button>-->

<!--          &lt;!&ndash; Beneficiaries container &ndash;&gt;-->
<!--          <div-->
<!--              ref="scrollContainer"-->
<!--              class="flex gap-6 overflow-x-auto scrollbar-hide px-8 py-4"-->
<!--              @scroll="updateScrollState"-->
<!--          >-->
<!--              &lt;!&ndash; New Beneficiary Card &ndash;&gt;-->
<!--              <div class="flex-shrink-0 flex flex-col items-center" @click="addNewBeneficiary">-->
<!--                  <div class="w-24 h-24 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center cursor-pointer hover:border-gray-400 transition-colors">-->
<!--                      <div class="w-8 h-8 rounded-full border-2 border-gray-400 flex items-center justify-center">-->
<!--                          <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>-->
<!--                          </svg>-->
<!--                      </div>-->
<!--                  </div>-->
<!--                  <p class="text-sm text-gray-500 mt-2 text-center">New Beneficiary</p>-->
<!--              </div>-->

<!--              &lt;!&ndash; Existing Beneficiaries &ndash;&gt;-->
<!--              <div-->
<!--                  v-for="beneficiary in props.beneficiaries"-->
<!--                  :key="beneficiary.id"-->
<!--                  class="flex-shrink-0 flex flex-col items-center cursor-pointer border-gray-400 bg-white shadow-md flex flex-col items-center bg-white px-6 py-4 rounded-lg shadow-md cursor-pointer transition-colors hover:bg-gray-100"-->
<!--                  @click="selectBeneficiary(beneficiary)"-->
<!--              >-->
<!--                  <div class="w-14 h-14 bg-primary rounded-full flex items-center justify-center text-white font-semibold text-lg">-->
<!--                      {{ beneficiary.initials }}-->
<!--                  </div>-->
<!--                  <p class="text-sm text-gray-700 mt-2 text-center">{{ beneficiary.name }}</p>-->
<!--              </div>-->
<!--          </div>-->

<!--          <button-->
<!--              @click="scrollRight"-->
<!--              class="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow text-gray-400 hover:text-gray-600 transition-colors"-->
<!--              :disabled="!canScrollRight"-->
<!--          >-->
<!--              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>-->
<!--              </svg>-->
<!--          </button>-->
<!--      </div>-->
<!--  </template>-->

<!--  <script setup>-->
<!--  import { ref, onMounted, nextTick, defineProps, defineEmits } from 'vue'-->

<!--  // Props-->
<!--  const props = defineProps({-->
<!--      beneficiaries: {-->
<!--          type: Array,-->
<!--          default: () => [-->
<!--              { id: 1, name: 'Gilbert Blake', initials: 'GB' },-->
<!--              { id: 2, name: 'Gilbert Blake', initials: 'GB' },-->
<!--              { id: 3, name: 'John Doe', initials: 'JD' },-->
<!--              { id: 4, name: 'Jane Smith', initials: 'JS' },-->
<!--          ]-->
<!--      }-->
<!--  })-->

<!--  // Emits-->
<!--  const emit = defineEmits(['select-beneficiary', 'add-new-beneficiary'])-->

<!--  // Refs-->
<!--  const scrollContainer = ref(null)-->
<!--  const canScrollLeft = ref(false)-->
<!--  const canScrollRight = ref(false)-->

<!--  // Methods-->
<!--  const selectBeneficiary = (beneficiary) => {-->
<!--      emit('select-beneficiary', beneficiary)-->
<!--  }-->

<!--  const addNewBeneficiary = () => {-->
<!--      emit('add-new-beneficiary')-->
<!--  }-->

<!--  const scrollLeft = () => {-->
<!--      if (scrollContainer.value) {-->
<!--          scrollContainer.value.scrollBy({ left: -200, behavior: 'smooth' })-->
<!--      }-->
<!--  }-->

<!--  const scrollRight = () => {-->
<!--      if (scrollContainer.value) {-->
<!--          scrollContainer.value.scrollBy({ left: 200, behavior: 'smooth' })-->
<!--      }-->
<!--  }-->

<!--  const updateScrollState = () => {-->
<!--      if (scrollContainer.value) {-->
<!--          const { scrollLeft, scrollWidth, clientWidth } = scrollContainer.value-->
<!--          canScrollLeft.value = scrollLeft > 0-->
<!--          canScrollRight.value = scrollLeft < scrollWidth - clientWidth - 1-->
<!--      }-->
<!--  }-->

<!--  // Lifecycle-->
<!--  onMounted(() => {-->
<!--      nextTick(() => {-->
<!--          updateScrollState()-->
<!--      })-->
<!--  })-->
<!--  </script>-->

<!--  <style scoped>-->
<!--  .scrollbar-hide {-->
<!--      -ms-overflow-style: none;-->
<!--      scrollbar-width: none;-->
<!--  }-->

<!--  .scrollbar-hide::-webkit-scrollbar {-->
<!--      display: none;-->
<!--  }-->
<!--  </style>-->













<!--<template>-->
<!--  <div class="relative">-->
<!--    &lt;!&ndash; Navigation arrows &ndash;&gt;-->
<!--    <button @click="scrollLeft" class="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow text-gray-400 hover:text-gray-600 transition-colors" :disabled="!canScrollLeft">-->
<!--      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>-->
<!--      </svg>-->
<!--    </button>-->

<!--    &lt;!&ndash; Beneficiaries container &ndash;&gt;-->
<!--    <div ref="scrollContainer" class="flex gap-6 overflow-x-auto scrollbar-hide px-8 py-4" @scroll="updateScrollState">-->
<!--      &lt;!&ndash; New Beneficiary Card &ndash;&gt;-->
<!--      <div class="flex-shrink-0 flex flex-col items-center" @click="addNewBeneficiary">-->
<!--        <div class="w-24 h-24 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center cursor-pointer hover:border-gray-400 transition-colors">-->
<!--          <div class="w-8 h-8 rounded-full border-2 border-gray-400 flex items-center justify-center">-->
<!--            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>-->
<!--            </svg>-->
<!--          </div>-->
<!--        </div>-->
<!--        <p class="text-sm text-gray-500 mt-2 text-center">New Beneficiary</p>-->
<!--      </div>-->

<!--      &lt;!&ndash; Existing Beneficiaries &ndash;&gt;-->
<!--      <div v-for="beneficiary in props.beneficiaries" :key="beneficiary.id"-->
<!--           class="flex-shrink-0 flex flex-col items-center cursor-pointer border-gray-400 bg-white shadow-md px-6 py-4 rounded-lg transition-colors hover:bg-gray-100"-->
<!--           @click="selectBeneficiary(beneficiary)">-->
<!--        <div class="w-14 h-14 bg-primary rounded-full flex items-center justify-center text-white font-semibold text-lg">-->
<!--          {{ beneficiary.initials || getInitials(beneficiary.description) }}-->
<!--        </div>-->
<!--        <p class="text-sm text-gray-700 mt-2 text-center">{{ beneficiary.description }}</p>-->
<!--        <p v-if="beneficiary.account_number" class="text-xs text-gray-500 text-center mt-1">{{ beneficiary.account_number }}</p>-->
<!--        <p v-if="beneficiary.iban" class="text-xs text-gray-500 text-center mt-1">{{ beneficiary.iban }}</p>-->
<!--      </div>-->

<!--    </div>-->

<!--    <button @click="scrollRight" class="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow text-gray-400 hover:text-gray-600 transition-colors" :disabled="!canScrollRight">-->
<!--      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>-->
<!--      </svg>-->
<!--    </button>-->
<!--  </div>-->
<!--</template>-->

<!--<script setup>-->
<!--import { ref, onMounted, nextTick, defineProps, defineEmits } from 'vue'-->

<!--const props = defineProps({-->
<!--  beneficiaries: { type: Array, default: () => [] }-->
<!--})-->

<!--const emit = defineEmits(['select-beneficiary', 'add-new-beneficiary'])-->

<!--const scrollContainer = ref(null)-->
<!--const canScrollLeft = ref(false)-->
<!--const canScrollRight = ref(false)-->

<!--const selectBeneficiary = (b) => emit('select-beneficiary', b)-->
<!--const addNewBeneficiary = () => emit('add-new-beneficiary')-->

<!--const scrollLeft = () => scrollContainer.value?.scrollBy({ left: -200, behavior: 'smooth' })-->
<!--const scrollRight = () => scrollContainer.value?.scrollBy({ left: 200, behavior: 'smooth' })-->

<!--const updateScrollState = () => {-->
<!--  if (scrollContainer.value) {-->
<!--    const { scrollLeft, scrollWidth, clientWidth } = scrollContainer.value-->
<!--    canScrollLeft.value = scrollLeft > 0-->
<!--    canScrollRight.value = scrollLeft < scrollWidth - clientWidth - 1-->
<!--  }-->
<!--}-->

<!--const getInitials = (text) => {-->
<!--  if (!text) return ''-->
<!--  return text.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()-->
<!--}-->


<!--onMounted(-->
<!--    () => nextTick(() => updateScrollState())-->
<!--)-->
<!--</script>-->

<!--<style scoped>-->
<!--.scrollbar-hide {-->
<!--  -ms-overflow-style: none;-->
<!--  scrollbar-width: none;-->
<!--}-->
<!--.scrollbar-hide::-webkit-scrollbar { display: none; }-->
<!--</style>-->


<template>
  <div class="relative">
    <!-- Left Arrow (only when needed) -->
    <button
        v-if="showArrows"
        @click="scrollLeft"
        class="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow text-gray-400 hover:text-gray-600 transition-colors"
        :disabled="!canScrollLeft"
        aria-label="Scroll left"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
      </svg>
    </button>

    <!-- Beneficiaries container -->
    <div
        ref="scrollContainer"
        class="flex gap-6 overflow-x-auto scrollbar-hide px-8 py-4"
        @scroll="updateScrollState"
    >
      <!-- New Beneficiary Card -->
      <div class="flex-shrink-0 flex flex-col items-center" @click="addNewBeneficiary">
        <div class="w-24 h-24 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center cursor-pointer hover:border-gray-400 transition-colors">
          <div class="w-8 h-8 rounded-full border-2 border-gray-400 flex items-center justify-center">
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
            </svg>
          </div>
        </div>
        <p class="text-sm text-gray-500 mt-2 text-center">New Beneficiary</p>
      </div>

      <!-- Existing Beneficiaries -->
      <div
          v-for="beneficiary in beneficiaries"
          :key="beneficiary.id"
          class="flex-shrink-0 flex flex-col items-center cursor-pointer border-gray-400 bg-white shadow-md px-6 py-4 rounded-lg transition-colors hover:bg-gray-100"
          @click="selectBeneficiary(beneficiary)"
      >
        <div class="w-14 h-14 bg-primary rounded-full flex items-center justify-center text-white font-semibold text-lg">
          {{ beneficiary.initials || getInitials(beneficiary.name) }}
        </div>
        <p class="text-sm text-gray-700 mt-2 text-center">{{ beneficiary.name }}</p>
        <p v-if="beneficiary.account_number && beneficiary.account_number!='-'" class="text-xs text-gray-500 text-center mt-1">{{ beneficiary.account_number }}</p>
        <p v-if="beneficiary.iban && beneficiary.iban!='-'" class="text-xs text-gray-500 text-center mt-1">{{ beneficiary.iban }}</p>
      </div>
    </div>

    <!-- Right Arrow (only when needed) -->
    <button
        v-if="showArrows"
        @click="scrollRight"
        class="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow text-gray-400 hover:text-gray-600 transition-colors"
        :disabled="!canScrollRight"
        aria-label="Scroll right"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
      </svg>
    </button>
  </div>
</template>

<script setup>
import { ref, nextTick, defineProps, defineEmits, computed, watch, onMounted, onUnmounted, toRef } from 'vue'

const props = defineProps({
  beneficiaries: { type: Array, default: () => [] }
})
const beneficiaries = toRef(props, 'beneficiaries')

const emit = defineEmits(['select-beneficiary', 'add-new-beneficiary'])

const scrollContainer = ref(null)
const canScrollLeft = ref(false)
const canScrollRight = ref(false)

// include "New Beneficiary" card in the count (+1)
const itemCount = computed(() => (beneficiaries.value ? beneficiaries.value.length : 0) + 1)
const showArrows = computed(() => itemCount.value > 4)

const selectBeneficiary = (b) => emit('select-beneficiary', b)
const addNewBeneficiary = () => emit('add-new-beneficiary')

const getScrollAmount = () => {
  if (!scrollContainer.value) return 200
  // Scroll roughly one "page" (80% of visible width)
  return Math.max(150, Math.floor(scrollContainer.value.clientWidth * 0.8))
}

const scrollLeft = () => {
  scrollContainer.value?.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' })
  // update state shortly after smooth scroll starts
  setTimeout(updateScrollState, 300)
}
const scrollRight = () => {
  scrollContainer.value?.scrollBy({ left: getScrollAmount(), behavior: 'smooth' })
  setTimeout(updateScrollState, 300)
}

function updateScrollState() {
  const el = scrollContainer.value
  if (!el) {
    canScrollLeft.value = false
    canScrollRight.value = false
    return
  }
  const { scrollLeft: sl, scrollWidth: sw, clientWidth: cw } = el
  const tolerance = 5
  canScrollLeft.value = sl > tolerance
  canScrollRight.value = sl < (sw - cw - tolerance)
}

const getInitials = (text) => {
  if (!text) return ''
  return text.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()
}

// initial setup + resize listener
onMounted(() => {
  nextTick(updateScrollState)
  window.addEventListener('resize', updateScrollState)
})

// when beneficiaries change, recalc (after DOM updated)
watch(beneficiaries, () => nextTick(updateScrollState))

onUnmounted(() => {
  window.removeEventListener('resize', updateScrollState)
})
</script>

<style scoped>
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar { display: none; }
</style>

